import { render, staticRenderFns } from "./RenewSbp.vue?vue&type=template&id=63e49968"
import script from "./RenewSbp.vue?vue&type=script&setup=true&lang=js"
export * from "./RenewSbp.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports